<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-price-list-templates">
        <i class="far fa-clipboard-list"></i> Pricelist Templates
      </Tab>
    </template>

    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-price-list-templates">
        <div class="row">
          <div class="col-lg-12">
            <DataTable :columns="templateColumnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="4" :url="templateListDataURL" :displayTools="true" :hasDateRangeFilter="true">
              <template v-slot:title>
                <h3>Price List Templates</h3>
              </template>
              <template v-slot:tools>
                <LinkButton type="new" href="/pricing/pricelisttemplates/new" v-if="userHasCreatePermission(PermissionTypes.PricingPermissionTypes.priceListTemplate)" sizeClass="btn"> New Pricelist Template</LinkButton>
              </template>
              <template v-slot:row="row">
                <tr :key="row.data.id">
                  <td class="table-data-nav-link">
                    <LinkPriceListTemplate :name="row.data.name" :id="row.data.id" :newTab="false" />
                  </td>
                  <td>
                    {{formatHyphenEmptyValue(row.data.description)}}
                  </td>
                  <td>
                    <IconBoolean :value="row.data.isActive" />
                  </td>
                  <td>
                    <LabelTags :labelList="row.data.labelList" />
                  </td>
                  <td>
                    {{formatDateTime(row.data.createdAt)}}
                  </td>
                </tr>
              </template>
            </DataTable>
          </div>
        </div>
      </TabPage>

    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: 'PriceListTemplateList',
  mixins: [form],
  components: {
    TabbedBox,
    Tab,
    TabPage,
    StaticDataTable
  },
  created() {
  },
  mounted() {
  },
  data: () => {
    return {
      templateColumnList: [
        { title: "Name", data: "name" },
        { title: "Description", data: "description" },
        { title: "Active", data: "isActive" },
        { title: "Labels", data: "labelList" },
        { title: "Created", data: "createdAt", dateFilter: true, type: 'datetime' },
      ],
      templateListDataURL: '/pricing/pricelisttemplates?'
    }
  },
  computed: {
  },
  methods: {
  }
}

</script>